import React from 'react';
import { InputWithAction } from '@cashfree-intl/coherent';

const AmountLabeledInput = props => <InputWithAction label=" ₹ " {...props} />;

export default AmountLabeledInput;
